// nosemgrep: no-legacy-api-store
import apiStore from '@/legacy/store/modules/apiBuilder'
import { KnowledgeBaseLlmResponse } from '@/libs/features/llm/types'

export const useKnowledgeBaseLlmApi = apiStore<KnowledgeBaseLlmResponse>(
  'llmKnowledgeBaseApi',
  '/api/llm/knowledge_base/sops'
)
